import {Link, isRouteErrorResponse, useRouteError} from 'react-router';
import {tr} from '../i18n/idioma';

// Direccion que no existe (dentro del marco, con el menu a la vista). Antes
// salia la pagina tecnica en ingles del enrutador (recorrido 7/10/2026).
export function PaginaNoEncontrada() {
  return <Aviso titulo={tr('Esta página no existe', 'This page does not exist')} />;
}

// Error inesperado al dibujar una pantalla: un aviso en el idioma de la app,
// sin detalles tecnicos, con salida al inicio.
export function PaginaDeError() {
  const error = useRouteError();
  const noExiste = isRouteErrorResponse(error) && error.status === 404;
  return (
    <div className="p-8">
      <Aviso
        titulo={
          noExiste
            ? tr('Esta página no existe', 'This page does not exist')
            : tr('Algo salió mal', 'Something went wrong')
        }
        detalle={
          noExiste
            ? undefined
            : tr(
                'La pantalla no se pudo mostrar. Vuelve a intentarlo; si se repite, avísale al equipo de la app.',
                'The screen could not be shown. Try again; if it happens again, let the app team know.',
              )
        }
      />
    </div>
  );
}

function Aviso({titulo, detalle}: {titulo: string; detalle?: string}) {
  return (
    <section className="max-w-xl rounded-lg border border-linea bg-white p-6" data-prueba="pagina-no-encontrada">
      <h1 className="text-2xl font-semibold text-verde-oscuro">{titulo}</h1>
      <p className="mt-2 text-sm text-apagado">
        {detalle ??
          tr(
            'La dirección no corresponde a ninguna pantalla. Puede ser un enlace viejo o mal escrito.',
            'The address does not match any screen. It may be an old or mistyped link.',
          )}
      </p>
      <Link
        to="/"
        className="mt-4 inline-block rounded-md bg-verde px-3 py-1.5 text-sm font-medium text-white hover:bg-verde-oscuro"
      >
        {tr('Volver al inicio', 'Back to home')}
      </Link>
    </section>
  );
}
